import { ajax } from 'application/src/js/functions.js';

/**
 * Modal window controller for displaying persons that were interested in certain products
 */
export default class TopInterestedDetailsModal {
  constructor(args) {
    this.modal = args.modal;
    this.translations = args.translations;
    this.loader = args.loader;
    this.store = args.store;
    this.mediator = args.mediator;
    this.contentArea = this.modal.element.querySelector('.top-interested-details');
    this.companyNameOut = this.modal.element.querySelector('.company-name');

    this.companyName = '';

    this.addEvents();
  }

  addEvents() {
    this.mediator.subscribe('showNotes', _ => this.modal.element.classList.add('hide'));
    this.mediator.subscribe('hideNotes', _ => this.modal.element.classList.remove('hide'));
  }

  show(params, companyName, addressId) {
    this.companyName = companyName;
    this.addressId = addressId;
    this.loader.show();
    this.modal.open();

    ajax('/analytics/clickDetails/ajaxLoadClickTopCompanyInfo', params)
      .then(response => {
        this.render(this.aggregate(response.data));
        this.loader.hide();
      })
      .catch(e => console.log(e));
  }

  aggregate(data) {
    const state = this.store.getState();

    return data.reduce((aggregatedData, d) => {
      const productName = state.products[d.global_product_basic_id];

      if(!aggregatedData[d.company_user_id]) {
        aggregatedData[d.company_user_id] = Object.assign({}, d, { interests: {} });
      }

      if(!aggregatedData[d.company_user_id].interests[productName]) {
        aggregatedData[d.company_user_id].interests[productName] = d.amount;
      }

      return aggregatedData;
    }, {});
  }

  render(data) {
    this.companyNameOut.innerHTML = this.companyName;
    this.contentArea.innerHTML = '';

    Object.values(data).map(interestedPersonData => {
      const interestedPersonElement = document.createElement('div');
      this.contentArea.insertAdjacentElement('beforeend', interestedPersonElement);

      new InterestedPerson({
        parent: this,
        element: interestedPersonElement,
        data: interestedPersonData,
        translations: this.translations
      });
    });
  }

  onShowNotes(interestedPersonData) {
    import( /* webpackChunkName: "manage-user-notes" */ 'application/src/js/user-notes/manage-user-notes.js')
      .then(({ default: ManageUserNotesController }) => {
        const manageUserNotesController = new ManageUserNotesController({
          isModal: true,
          subHeadline: this.companyName
        });
        manageUserNotesController.modal.subscribe('open', _ => this.mediator.publish('showNotes'));
        manageUserNotesController.modal.subscribe('close', _ => this.mediator.publish('hideNotes'));
        manageUserNotesController.load(this.addressId);
      });
  }
}

class InterestedPerson {
  constructor(args) {
    this.parent = args.parent;
    this.element = args.element;
    this.data = args.data;
    this.interests = args.interests;
    this.translations = args.translations;

    this.render();
  }

  render() {
    this.element.classList.add('interested-user');
    this.element.innerHTML = this.template;
    this.showNotesButton = this.element.querySelector('.show-notes');

    this.addEvents();
  }

  addEvents() {
    this.showNotesButton.addEventListener('click', _ => this.parent.onShowNotes(this.data))
  }

  get template() {
    return `
      <div class="user-title">
        <user-info
          company-user-id="${this.data.company_user_id}"
          firstname="${this.data.user_firstname}"
          lastname="${this.data.user_lastname}"
          company-name="${this.data.name}"
        </user-info>
      </div>

      <div class="user-contact">
        ${this.data.user_mail ? `
          <div>
            <i class="fas fa-envelope-square"></i>
            <a href="mailto:${this.data.user_mail}">${this.data.user_mail}</a>
          </div>
        ` : ``}

        ${this.data.user_phone ? `
          <div>
            <i class="fas fa-phone-square"></i>
            <a href="tel:${this.data.user_phone.replace(/\s/g, '')}">${this.data.user_phone}</a>
          </div>
        ` :
        `<div>
            <i class="fas fa-phone-square"></i>
            <a href="tel:${this.data.phone.replace(/\s/g, '')}">${this.data.phone}</a>
         </div>`
         }

        ${this.data.skype ? `
          <div>
            <i class="fab fa-skype"></i>
            <a href="skype:${this.data.skype}?call">${this.data.skype}</a>
          </div>
        ` : ``}
      </div>
      <div class="user-interests">
        ${Object.keys(this.data.interests).length ? `
          ${
            Object.keys(this.data.interests).map(productName => `
              ${productName} (${this.data.interests[productName]} ${this.translations[this.data.interests[productName] > 1 ? `clicks` : `click`]})<br>
            `).join('')
          }
        ` : ``}
      </div>
      <div class="buttons"><a class="button small show-notes">${this.translations.interestedPersons.notes}</a></div>
    `
  }
}